<template>
  <md-tab id="tab-industry" md-label="Industry" md-icon="business">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 order-2">
        <div>
          <PulseLoader :loading="!loaded" :class="{ hide: loaded }"></PulseLoader>
        </div>
        <div v-if="mSearchIndustries == null && !mSearchLoadingIndustry">
          <div v-for="(len2, len2Index) in industriesLen2" :key="len2Index"
            :class="checkLen2()?`len2-${getData(len2)} available unclicked`:`len2-${getData(len2)} unavailable unclicked`" @click="getIndustriesLenN($event)">

            {{ len2 }}
          </div>
        </div>
        <!-- <div>
          <pulse-loader
            :color="'blue'"
            :loading="mSearchLoadingIndustry && mSearchIndustries == null"
          ></pulse-loader>
        </div> -->
        <div class="searchDiv" v-show="mSearchIndustries != null" @click="chooseSearchResult($event)"></div>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 search_panel">
        <sidebar-search @load-industry="loadIndustry" tab="industry" title="Favorite Industries" />
      </div>
    </div>
  </md-tab>
</template>

<script>
import SidebarSearch from './SidebarSearch';
import axios from 'axios';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { PulseLoader } from '@/components';
import Vue from 'vue';

export default {
  name: 'industry-tab',
  props: {},
  components: {
    SidebarSearch,
    PulseLoader,
  },
  data() {
    return {
      apiIndustries: undefined,
      industriesLen2: [],
      loaded: false,
    };
  },
  methods: {
    /**
     * Taxonomy level of a bznaics: 2-6 for whole codes, then 8/10/12/14 for the
     * 2-digit sub-segments. bznaics is a DECIMAL in the database and MySQL strips
     * trailing zeros, so 722511.0210 reaches us as 722511.021 -- the fraction has to
     * be padded back to an even length before its length means anything. This mirrors
     * igdb_taxonomy_2022.code_level; 462 codes read a level too shallow without it.
     */
    bznaicsLevel: function (code) {
      const s = String(code == null ? '' : code).trim();
      const dot = s.indexOf('.');
      if (dot === -1) {
        return s.length;
      }
      let frac = s.slice(dot + 1);
      if (frac.length % 2) {
        frac += '0';
      }
      return 6 + frac.length;
    },
    /**
     * Indent step for one row, ranked against the levels present in THIS list rather
     * than against an absolute scale -- a drill that returns only level-8 rows should
     * render flush, not indented four times. Stateless on purpose: the previous
     * implementation carried a running multiplier, so a single mis-measured row
     * displaced every row beneath it.
     */
    bznaicsIndent: function (code, levels) {
      const ladder = Array.from(new Set(levels)).sort(function (a, b) { return a - b; });
      const at = ladder.indexOf(this.bznaicsLevel(code));
      return 24 * (at < 0 ? 0 : at);
    },
    checkLen2: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].impAccess.naics2)
          return true;
        else
          return false;
      else
        return true;
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    loadIndustry: function (e) {
      this.loaded = !e.isLoading;
    },
    chooseSearchResult: function (event) {
      const bznaics = this.getData(event.target.innerText);
      const title = this.getName(event.target.innerText);

      this.$store.commit('M_SET_INDUSTRY', `${title} [${bznaics}]`);
    },
    generateSearchIndustries: function () {
      const currentDiv = document.querySelector('.searchDiv');

      while (currentDiv.firstChild) {
        currentDiv.removeChild(currentDiv.lastChild);
      }
      if (this.mSearchIndustries[0].length == 0) {
        let elementToAppend = document.createElement('div');
        elementToAppend.setAttribute('class', 'available');
        elementToAppend.textContent =
          'No results! Please try different keyword.';
        currentDiv.appendChild(elementToAppend);
      }

      const searchLevels = this.mSearchIndustries[0].map((i) =>
        this.bznaicsLevel(this.getData(i)));
      this.mSearchIndustries[0].forEach((industry) => {
        let elementToAppend = document.createElement('div');
        const bznaics = this.getData(industry);


        elementToAppend.setAttribute(
          'class',
          `search-${bznaics} ${this.mSearchIndustries[1].includes(industry)
            ? 'available'
            : 'unavailable'
          } `
        );
        if (bznaics.length > 5) {
          elementToAppend.setAttribute(
            'style',
            `padding-left: ${this.bznaicsIndent(bznaics, searchLevels)}px`
          );
        }

        elementToAppend.textContent = industry;
        currentDiv.appendChild(elementToAppend);
      });
    },
    getName: function (name) {
      return name.split('[')[0];
    },
    getSearchState: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      let route = null;
      if (this.$route.name === 'NewMarketProfile')
        route = '/user/search_profiles/imr';
      else
        route = '/user/search_reports/imr';
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/imr" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('M_SET_PROFILE_ID', id);
        });
    },

    getIndustries: async function () {
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/industries', {
          params: {
            type: 'imr',
            industry: '0',
            area: 0,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.apiIndustries = res.data.data;
          this.industriesLen2 = [];
          this.apiIndustries.forEach((industry) => {
            this.industriesLen2.push(`${industry.name} [${industry.bznaics}]`);
          });
          this.loaded = true;
        });
    },
    checkBznaicsPermission: function(bznaics){
      if(this.$store.getters["user/userAccess"] && this.$store.getters["user/userAccess"].impAccess){
        let impAccess = this.$store.getters["user/userAccess"].impAccess;
        if(impAccess[`naics${bznaics.length}`])
          return true;
        else if(bznaics.length == 6 && bznaics.inclues('.')){
            let naicsNumberSplitted = bznaics.split('.')[1]
        if(impAccess[`naics6_${naicsNumberSplitted.length}`])
          return true;
        }
        else
          return false;
      }
      else
        return true;
      },
    getIndustriesLenN: async function (event) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      let resZips = '0';
      let resArea = 0;
      let resMap_center = '0';
      let resMap_center_zip = '0';
      let resRadius = '0';
      let route = null;
      if (this.$route.name === 'NewMarketProfile')
        route = '/user/search_profiles/imr';
      else
        route = '/user/search_reports/imr';

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.mIndustry),
              area: this.getData(this.mMarketArea),
              zips: this.mMarketArea && this.mMarketArea.includes('zips') ? this.mMarketArea.split('[')[0] : null,
              map_center: '0',
              map_center_zip: '0',
              radius: '0',
              type: 'imr',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/imr" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const {
            id,
            area,
            zips,
            map_center,
            map_center_zip,
            radius,
          } = res.data;
          this.$store.commit('M_SET_PROFILE_ID', id);
          resZips = this.mMarketArea && this.mMarketArea.includes('zips') ? this.mMarketArea.split('[')[0] : null;
          resArea = this.getData(this.mMarketArea);
          resMap_center = map_center;
          resMap_center_zip = map_center_zip;
          resRadius = radius;
        });
      let availableIndustries = [];

      const query = event.target.className.split(' ')[0];
      const bznaics = this.getData(event.target.innerText);
      const title = this.getName(event.target.innerText);

      this.$store.commit('M_SET_INDUSTRY', `${title} [${bznaics}]`);
      let classAux = document.getElementsByClassName(query);
      const currentDiv = classAux[0];

      if (bznaics.length > 6) {
        return;
      }

      if (currentDiv.classList.contains('unclicked')) {
        let loadingDiv = document.createElement('div');
        let loadingMount = document.createElement('div');

        loadingDiv.setAttribute('class', 'available');
        loadingDiv.appendChild(loadingMount);

        currentDiv.appendChild(loadingDiv);

        const pulseLoader = Vue.extend(PulseLoader);
        const pulseLoaderToMount = new pulseLoader({
          propsData: {
            color: 'blue',
            loading: true,
          },
        }).$mount(loadingMount);

        currentDiv.classList.remove('unclicked');
        currentDiv.classList.add('clicked');

        //Available Industries
        await axios
          .get(process.env.VUE_APP_API_BASE_URL + '/info/industries', {
            params: {
              type: 'imr',
              industry: this.getData(this.mIndustry),
              area: resArea,
              zips: resZips,
              map_center: resMap_center,
              map_center_zip: resMap_center_zip,
              radius: resRadius,
            },
          })
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }
            this.apiIndustries = res.data.data;
            const apiLevels = this.apiIndustries.map((i) =>
              this.bznaicsLevel(i.bznaics));
            this.apiIndustries.forEach((industry) => {
              availableIndustries.push(
                `${industry.name} [${industry.bznaics}]`
              );
            });
          });

        await axios
          .get(process.env.VUE_APP_API_BASE_URL + '/info/industries', {
            params: {
              type: 'imr',
              industry: bznaics,
              area: 0,
            },
          })
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }
            while (currentDiv.firstChild != currentDiv.lastChild) {
              currentDiv.removeChild(currentDiv.lastChild);
            }
            this.apiIndustries = res.data.data;
            this.apiIndustries.forEach((industry) => {
              let elementToAppend = document.createElement('div');
              elementToAppend.setAttribute(
                'class',
                `len2-${industry.bznaics} ${availableIndustries.includes(
                  `${industry.name} [${industry.bznaics}]`
                ) && this.checkBznaicsPermission(industry.bznaics)
                  ? 'available'
                  : 'unavailable'
                } unclicked`
              );
              if (industry.bznaics.length > 5) {
                elementToAppend.setAttribute(
                  'style',
                  `padding-left: ${this.bznaicsIndent(industry.bznaics, apiLevels)}px`
                );
              }
              elementToAppend.textContent = `${industry.name} [${industry.bznaics}]`;
              currentDiv.appendChild(elementToAppend);
            });
          });
      } else {
        while (currentDiv.firstChild != currentDiv.lastChild) {
          currentDiv.removeChild(currentDiv.lastChild);
        }
        currentDiv.classList.remove('clicked');
        currentDiv.classList.add('unclicked');
      }
    },
  },
  async created() {
    await this.getSearchState();
    await this.getIndustries();
  },
  computed: {
    profileId() {
      return this.$store.getters.mProfileId;
    },
    mIndustry() {
      return this.$store.getters.mIndustry;
    },
    mMarketArea() {
      return this.$store.getters.mMarketArea;
    },
    mSearchIndustries() {
      return this.$store.getters.mSearchIndustries;
    },
    mSearchInputIndustry() {
      return this.$store.getters.mSearchInputIndustry;
    },
    mSearchLoadingIndustry() {
      return this.$store.getters.mSearchLoadingIndustry;
    },
  },
  watch: {
    // mIndustry(newValue, oldValue) {
    //   this.getIndustries();
    // },
    // mMarketArea(newValue, oldValue) {
    //   this.getIndustries();
    // },
    mSearchIndustries(newValue, oldValue) {
      if (this.mSearchIndustries != null) {
        this.generateSearchIndustries();
      }
    },
  },
};
</script>
<style lang="scss">
.unavailable {
  pointer-events: none;
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  margin: 16px;
}

.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
  transition: 0.5s;
}

.search-indent {
  padding-left: 32px;
}

.available:hover {
  color: #1a7bfa;
  transition: 0.5s;
}
</style>
